import type { PropsWithChildren } from 'react';
import React from 'react';
import type { FieldValues } from 'react-hook-form';
import { useErrorNotification } from '../create-plan-context/CreatePlanProvider/hooks/use-error-notification';
import { createFormErrorNotificationContext } from './form-error-notification-context';

export function FormErrorNotificationProvider<
  InputForm extends FieldValues,
  Tab extends string | undefined = undefined,
>({ children }: PropsWithChildren<object>) {
  const FormErrorNotificationContext = createFormErrorNotificationContext<InputForm, Tab>();
  const errorNotification = useErrorNotification<InputForm, Tab>();

  return (
    <FormErrorNotificationContext.Provider value={errorNotification}>
      {children}
    </FormErrorNotificationContext.Provider>
  );
}
